import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { deleteFeeSchedule } from 'Services/JOONAdmin/joonAdminEmployersService'

export const useDeleteFeeScheduleQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.DeleteFeeSchedule], deleteFeeSchedule, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerDashboard])
        toast.success(AppNotification.DeleteFeeScheduleSuccess)
      } else {
        toast.error(`${AppNotification.DeleteFeeScheduleFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.DeleteFeeScheduleFailure)
    }
  })
}
